<template>
  <SelectWithSearch
    v-model="input"
    label="Tributação"
    labelBusca="description"
    :change="change"
    :options="search"
    :search="onSearch"
  >
    <template slot="options" slot-scope="props">
      <div class="selected">
        {{ props.data.description }}
      </div>
    </template>
    <template slot="no-options"> Selecione uma tributação </template>
    <template slot="selected" slot-scope="props">
      <div class="selected">
        {{ props.data.description }}
      </div>
    </template>
  </SelectWithSearch>
</template>

<script>
import SearchMixin from '@/core/mixins/SearchMixin';
import { SelectWithSearch } from '@/components/Form';
import { mapState } from 'vuex';

export default {
  name: 'AutocompleteTax',
  components: {
    SelectWithSearch,
  },
  mixins: [SearchMixin],
  props: {
    value: {},
  },
  data() {
    return {
      collection: [],
      search: [],
      input: undefined,
    };
  },
  watch: {
    value(current) {
      this.input = current;
    },
  },
  mounted() {
    this.getCollection();

    if (this.service.fiscal.tributes) {
      this.input = this.service.fiscal.tributes;
    }
  },
  computed: {
    ...mapState('service', ['service']),
  },
  methods: {
    async getCollection() {
      const { data } = await this.$http.post(
        'consumers.find-summary-service-tributes',
      );
      this.collection = data;
      this.search = data;
    },
    onSearch(value) {
      this.search = this.searchCollection(
        this.collection,
        value,
        'description',
      );
    },
    change(value) {
      this.$emit('input', value);
    },
  },
};
</script>
